export default __webpack_public_path__ + "static/media/auredb.eb7d04fd.png";